import React from 'react'
import Select from "components/form/select/select";
// import classNames from "classnames";

const states = ['AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'];
const options = states.map(state => ({value: state, name: state}));

const StateDropdown = props =>
    // StateDropdown wraps custom select component
    <Select
        options={options}
        placeholder={'State'}
        error={props.error ? true : false}
        {...props}
    >
        Select State
    </Select>

export default StateDropdown
